import SubMenu from "@/admin/components/common/SubMenu/SubMenu";
import Dropzone from "@/admin/components/common/dropzone/Dropzone";
import Logo from "@/common/components/Logo/Logo";
import { RootState } from "@/rematch/store/store";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Nav, NavItem } from "reactstrap";
const navigation = [
  {
    title: "Tableau de bord",
    to: "Dashboard",
    icon: "bi bi-speedometer2",
  },
  {
    title: "Utilisateurs",
    to: "User",
    icon: "bi bi-person",
  },
  {
    title: "Pages",
    to: "Index",
    icon: "bi bi-file-earmark",
  },

  {
    title: "Médiathèque",
    to: "Media",
    icon: "bi bi-images",
  },

  {
    title: "Paramètres",
    to: "#",
    icon: "bi bi-gear-fill",
    submenus: [
      {
        title: "Langues",
        to: "Language",
      },
      {
        title: "Pied de Page",
        to: "Footer",
      },
    ],
  },
];

const Sidebar = ({ showMobilemenu }: any) => {
  const dispatch = useDispatch();
  function navigateTo(page: string) {
    dispatch.pageModel.setPage({ page: page });
  }
  const { page } = useSelector((state: RootState) => state.pageModel);

  const [modal, setModal] = useState(false);

  const closeModal = () => {
    setModal(false);
    console.log(modal);
  };

  const toggle = () => {
    setModal(!modal);
  };

  const closeBtn = (
    <button
      className="btn"
      style={{ fontSize: 16 }}
      onClick={toggle}
      type="button"
    >
      &times;
    </button>
  );

  const openToast = (message: string) => {
    dispatch.toastModel.setShowToast({ showToast: true, message: message });
  };

  const importData = (formData: any) => {
    dispatch.translationModel
      .importTranslations(formData)
      .then((res: any) => {
        openToast("translations has been updated");
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return (
    <>
      <div className="p-3 fixedMenu">
        <div className="d-flex align-items-center justify-content-center mt-5">
          <Logo />
        </div>
        <div className="pt-4 mt-2">
          <Nav vertical className="sidebarNav">
            {navigation.map((navi, index) =>
              navi.submenus ? (
                <SubMenu
                  key={index}
                  title={navi.title}
                  icon={navi.icon}
                  items={navi.submenus}
                  page={page}
                />
              ) : (
                <NavItem key={index} className="sidenav-bg">
                  <a
                    className={
                      "nav-link text-secondary py-3 pointer d-inline-flex"
                    }
                    onClick={() => navigateTo(navi.to)}
                  >
                    <i
                      className={navi.icon}
                      style={{
                        color: navi.to === page ? "#c00820" : "",
                      }}
                    ></i>
                    <span className="ms-3 d-inline-block" style={{
                        fontWeight: navi.to === page ? "600" : "initial",
                      }}> {navi.title}</span>
                  </a>
                </NavItem>
              )
            )}
            <div className="position-fixed bottom-0 start-0 mt-5">
              <button className="btn" onClick={toggle}>
                <i className="bi bi-translate"></i>
              </button>
            </div>
          </Nav>
        </div>
      </div>

      {modal && (
        <Dropzone modal={modal} toggle={toggle} importData={importData} />
      )}
    </>
  );
};

export default Sidebar;
